import {useEffect, useState} from "react";
import store from "storejs";

export const useGetDefaultCountry = () => {
    const [defaultCountry, setDefaultCountry] = useState(store('default_country'));
    useEffect(() => {
        const handleStorage = (event) => {
            console.log(event);
            setDefaultCountry(store('default_country'));
        };
        window.addEventListener('storageChange', handleStorage, false);

        return () => {
            window.removeEventListener('storageChange', handleStorage)
        };
    },[])

    return defaultCountry;
}